// @flow
import { connect } from 'react-redux';

import { getForgotPasswordError, getForgotPasswordSuccess } from 'redux/User/selectors';
import { forgotPasswordRequest } from 'redux/User/actions';
import ForgotPassword from './ForgotPassword.component';
import type { DispatchPropsType } from './ForgotPassword.component';

const mapStateToProps = (state: StoreType): DashboardStore => ({
  successMessage: getForgotPasswordSuccess(state),
  setErrorMessage: getForgotPasswordError(state),
});

const mapDispatchToProps = (dispatch: Function): DispatchPropsType => ({
  forgotPasswordRequest: (email, recaptcha) => dispatch(forgotPasswordRequest(email, recaptcha)),
});

export default (connect(mapStateToProps, mapDispatchToProps)(ForgotPassword): any);
